import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

/** GET /warning-letter?pks_id=&mitra_id=&warning_level=&status=&page=&limit= */
export async function getWarningLetters(queryParams = "", extraHeaders = {}) {
  return await instance({ baseURL }).get("/warning-letter" + queryParams, {
    headers: extraHeaders,
  });
}

/** GET /warning-letter/:id */
export async function getWarningLetterById(id) {
  return await instance({ baseURL }).get(`/warning-letter/${id}`);
}

/** GET /warning-letter/pks/:pks_id */
export async function getWarningLettersByPKS(pks_id) {
  return await instance({ baseURL }).get(`/warning-letter/pks/${pks_id}`);
}

/** GET /warning-letter/mitra/:mitra_id */
export async function getWarningLettersByMitra(mitra_id) {
  return await instance({ baseURL }).get(`/warning-letter/mitra/${mitra_id}`);
}

/** POST /warning-letter */
export async function createWarningLetter(body) {
  return await instance({ baseURL }).post("/warning-letter", body);
}

/** PUT /warning-letter/:id */
export async function updateWarningLetter(id, body) {
  return await instance({ baseURL }).put(`/warning-letter/${id}`, body);
}

/** DELETE /warning-letter/:id */
export async function deleteWarningLetter(id) {
  return await instance({ baseURL }).delete(`/warning-letter/${id}`);
}

/** POST /warning-letter/:id/issue */
export async function issueWarningLetter(id, body) {
  return await instance({ baseURL }).post(`/warning-letter/${id}/issue`, body);
}

/** POST /warning-letter/:id/deliver */
export async function deliverWarningLetter(id, body) {
  return await instance({ baseURL }).post(`/warning-letter/${id}/deliver`, body);
}

/** POST /warning-letter/:id/acknowledge */
export async function acknowledgeWarningLetter(id, body) {
  return await instance({ baseURL }).post(`/warning-letter/${id}/acknowledge`, body);
}

/** POST /warning-letter/:id/resolve */
export async function resolveWarningLetter(id, body) {
  return await instance({ baseURL }).post(`/warning-letter/${id}/resolve`, body);
}

/** POST /warning-letter/:id/escalate */
export async function escalateWarningLetter(id) {
  return await instance({ baseURL }).post(`/warning-letter/${id}/escalate`);
}
